import { graphql } from "@/lib/gql/__generated__";

export const RoomPriceRankDailyStatusUpdate_RoomPriceRankPage_Mutation = graphql(`
	mutation RoomPriceRankDailyStatusUpdate_RoomPriceRankPage($input: RoomPriceRankDailyStatusInput!) {
		roomPriceRankDailyStatusUpdate(input: $input) {
			userErrors
			priceRankDailyStatus {
				id
				hotelID
				statuses {
					hotelID
					date
					color
					priceRankID
				}
			}
		}
	}
`);
